export default __webpack_public_path__ + "static/media/9G.82ff5a0b.png";